import { formatTaskKey, type TaskSummary } from '@todo/shared';

/**
 * The reason prompt a drag-onto-Blocked pauses for (see useDragToStatus).
 * Same shape as My Day's own inline version - lifted out so the other
 * draggable board pages do not each carry a copy.
 */
export function BlockReasonModal({
  task, reason, busy, onReasonChange, onConfirm, onCancel,
}: {
  task: TaskSummary;
  reason: string;
  busy: boolean;
  onReasonChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="fixed inset-0 z-40 grid place-items-center bg-slate-900/40 p-4">
      <form
        onSubmit={(e) => { e.preventDefault(); onConfirm(); }}
        className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-5 shadow-xl"
      >
        <h2 className="text-base font-semibold text-slate-900">
          Block {formatTaskKey(task.taskKey)}
        </h2>
        <p className="mt-1 text-sm text-slate-500">
          Say what is blocking it - the reason is recorded on the task.
        </p>
        <input
          autoFocus
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          maxLength={500}
          placeholder="Waiting on client approval"
          className="mt-4 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-brand-500 focus:ring-2 focus:ring-brand-100"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onCancel}
            className="rounded-lg px-3.5 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100">
            Cancel
          </button>
          <button type="submit" disabled={!reason.trim() || busy}
            className="rounded-lg bg-red-600 px-3.5 py-2 text-sm font-medium text-white transition hover:bg-red-700 disabled:opacity-60">
            Mark blocked
          </button>
        </div>
      </form>
    </div>
  );
}
